import {
  NotificationsSettings,
  GetNotificationsSettingsListParams,
  CreateNotificationsSettingsPayload,
  UpdateNotificationsSettingsPayload,
  UpdateNotificationsPreferencesPayload,
} from 'features/settings/types/notificationTypes';

import { WellframeApi } from 'store/api';

// Mobile API does different things based on what values are sent in the request body,
// so we strip blank fields to avoid unintended behavior.
const stripBlankFields = (
  body: CreateNotificationsSettingsPayload,
): CreateNotificationsSettingsPayload => {
  const cleaned = { ...body };

  if (!cleaned.notification_type?.trim()) {
    delete cleaned.notification_type;
  }

  if (!cleaned.notification_channel?.trim()) {
    delete cleaned.notification_channel;
  }

  return cleaned;
};

export const notificationService = WellframeApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationsSettingsList: builder.query<
      NotificationsSettings[],
      GetNotificationsSettingsListParams
    >({
      query: ({ memberUuid, hospitalUuid, pageIndex, pageSize }) => ({
        url: `/mobileapi/v1/members/${memberUuid}/notifications-settings`,
        method: 'GET',
        params: {
          hospitalUuid,
          pageIndex,
          pageSize,
        },
      }),
    }),

    createNotificationsSettings: builder.mutation<
      void,
      { memberUuid: string; body: CreateNotificationsSettingsPayload }
    >({
      query: ({ memberUuid, body }) => ({
        url: `/mobileapi/v1/members/${memberUuid}/notifications-settings`,
        method: 'POST',
        body: stripBlankFields(body),
      }),
    }),

    updateNotificationsSettings: builder.mutation<
      void,
      { memberUuid: string; settingUuid: string; body: UpdateNotificationsSettingsPayload }
    >({
      query: ({ memberUuid, settingUuid, body }) => ({
        url: `/mobileapi/v1/members/${memberUuid}/notifications-settings/${settingUuid}`,
        method: 'PUT',
        body,
      }),
    }),

    updateNotificationsPreferences: builder.mutation<
      void,
      { memberUuid: string; body: UpdateNotificationsPreferencesPayload }
    >({
      query: ({ memberUuid, body }) => ({
        url: `/mobileapi/v1/members/${memberUuid}/notifications-settings`,
        method: 'PATCH',
        body,
      }),
    }),
  }),
});

export const {
  useGetNotificationsSettingsListQuery,
  useLazyGetNotificationsSettingsListQuery,
  useCreateNotificationsSettingsMutation,
  useUpdateNotificationsSettingsMutation,
  useUpdateNotificationsPreferencesMutation,
} = notificationService;
